import React from "react";
import PropTypes from "prop-types";

const FALLBACK_MARK = "ARTICLE";

/**
 * Typographic cover for an article that has no artwork yet: the organisation
 * name set large in the display face on the paper (or slab) surface.
 *
 * It is a designed surface, not a scaffold, so nothing on it says "image
 * missing". It is decorative: Cover renders it inside an aria-hidden frame,
 * the way an image with empty alt would be.
 */
const ArticlePlaceholder = ({ org = "", dark = false }) => {
	const bg = dark ? "var(--pp-slab)" : "var(--pp-surface)";
	const markC = dark ? "rgba(255,255,255,0.07)" : "rgba(13,13,13,0.07)";
	const mark = org || FALLBACK_MARK;

	return (
		<div
			className="relative w-full overflow-hidden"
			style={{ aspectRatio: "16/9", background: bg, containerType: "inline-size" }}
		>
			{/* Sized against the card (cqw) so the whole word fits: a name cut
			    mid-letter reads as a broken image. */}
			<div
				aria-hidden="true"
				className="absolute inset-0 flex items-end overflow-hidden px-4 pb-3 select-none pointer-events-none"
			>
				<span
					className="font-sligoil font-bold leading-none whitespace-nowrap"
					style={{
						fontSize: `clamp(1.5rem, ${Math.max(9, 150 / Math.max(4, mark.length))}cqw, 5rem)`,
						color: markC,
						letterSpacing: "-0.02em",
					}}
				>
					{mark}
				</span>
			</div>
		</div>
	);
};

ArticlePlaceholder.propTypes = {
	org: PropTypes.string,
	dark: PropTypes.bool,
};

export default ArticlePlaceholder;
